<template>
    <div class="bg-slate-100 rounded-[8px] py-2.5 px-4 min-h-6">
        <div class="text-xs text-slate-500">
            <slot name="label"></slot>
        </div>
        <div class="text-sm font-semibold">
            <slot></slot>
        </div>
    </div>
</template>

<script setup></script>
